import { useEffect, useRef, useState } from "react";
import { connectNotifications } from "@/socket";
import { getToken } from "@/helpers/cookiesHelper";
import { useLazyGetFeedNewCountQuery } from "@/store/api/postApi";

export function useFeedNewPostsCount() {
  const token = getToken();
  const createdRef = useRef(false);
  const [count, setCount] = useState(0);
  const [triggerGetCount] = useLazyGetFeedNewCountQuery();
  const suppressUntilRef = useRef(0);

  useEffect(() => {
    if (!token) return;
    if (createdRef.current) return;

    const socket = connectNotifications(token);
    createdRef.current = true;

    const onNewCount = (data: { count: number }) => {
      if (typeof data?.count !== "number") return;
      if (Date.now() < suppressUntilRef.current) return;
      setCount(data.count);
    };

    const onConnect = () => {
      triggerGetCount()
        .unwrap()
        .then((res) => {
          if (typeof res?.count === "number" && Date.now() >= suppressUntilRef.current) {
            setCount(res.count);
          }
        })
        .catch(() => {});
    };

    socket.on("connect", onConnect);
    socket.on("feed:new-count", onNewCount);

    return () => {
      socket.off("connect", onConnect);
      socket.off("feed:new-count", onNewCount);
      createdRef.current = false;
    };
  }, [token, triggerGetCount]);

  const resetCount = () => {
    suppressUntilRef.current = Date.now() + 3000;
    setCount(0);
  };

  return { count, resetCount };
}
